import ListingMainImageWithUploadOption from './ListingMainImageWithUploadOption.component';

export default ListingMainImageWithUploadOption;
